import script from "./InstalmentsDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstalmentsDetails.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__